<template>
  <div style="width: 10rem;" class="animate__animated animate__fadein animate__delay-0.5s animate__slower">
    <Navno></Navno>
    <Banner></Banner>
  </div>
</template>

<script>
import Navno from '../layout/nav-no.vue'
export default {
  components: {
    Navno
  }
  ,
  created() {
    localStorage.clear();
  }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/pages/index-no.vue